import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Color, Size } from '../../../const'
import { Button } from '../../shard'

export const WithdrawConfirmModal = ({ display, overlayOnClick, yesButtonClick, noButtonClick }) => (
  <Wrapper display={display ? 1 : 0}>
    <Overlay onClick={overlayOnClick}></Overlay>
    <Content>
      <Title>本当に退会しますか？</Title>
      <Separator />
      <Text>My TANAKA退会の場合には、以下のサービスを受けることができなくなります。</Text>
      <Text>1.ご購入商品の履歴や保証書の確認ができなくなります(保証内容や期間は変更されないのでご安心ください)。</Text>
      <Text>2.保証期限やサービスのお知らせが届かなくなります。</Text>
      <Text>退会後、再度My TANAKAへの登録をご希望される場合は、店舗にご来店の上スタッフにお申し付けください。</Text>
      <ButtonWrapper>
        <Button type="button" width={254} primary onClick={noButtonClick}>
          キャンセル
        </Button>
      </ButtonWrapper>
      <ButtonWrapper>
        <Button type="button" width={254} onClick={yesButtonClick}>
          退会する
        </Button>
      </ButtonWrapper>
      <Caution>
        ※「はい」をクリックして頂くと、退会完了となります。退会完了メールがご登録のメールアドレスに届きます。
      </Caution>
    </Content>
  </Wrapper>
)

const getDisplay = (props) => {
  let display = 'none'

  if (props.display || props.display === 1) {
    display = 'inline'
  }

  return display
}

const Wrapper = styled.div`
  ${(props) => css`
    display: ${getDisplay(props)};
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
  `}
`
const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  height: 100vh;
  width: 100%;
`
const Content = styled.div`
  background: ${Color.BACKGROUND.BASE};
  position: absolute;
  top: 50%;
  left: 50%;
  box-sizing: border-box;
  min-width: 239px;
  max-width: 294px;
  transform: translate(-50%, -50%);
  padding: 0 20px;
  text-align: center;
  border-radius: 8px;
`
const Title = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  margin: 30px 0 20px;
  line-height: 30px;
`
const Separator = styled.hr`
  border-top: 1px solid ${Color.LINE.NORMAL};
  border-bottom: 0;
`
const Text = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.REGULAR};
  text-align: left;
  padding: 16px 0;
`
const Caution = styled.div`
  color: ${Color.FONT.ANNOTATION};
  font-size: ${Size.FONT.REGULAR};
  margin: 30px 0;
  text-align: left;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px 0;
`

WithdrawConfirmModal.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  caution: PropTypes.string,
  display: PropTypes.bool,
  overlayOnClick: PropTypes.func,
  buttonOnClick: PropTypes.func,
  button: PropTypes.string,
}
